import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Collection } from '../../../shop/models';
import * as fromShopify from '../../../shop';
// import { CardGridAnimation } from '../../../animations';
import { trigger } from '@angular/animations';
import { SetTags, SetTitle } from '../../../store';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';
import { Breadcrumb } from 'src/app/core/models/breadcrumb.model';

@Component({
    selector: 'app-collection-overview',
    templateUrl: './collection-overview.component.html',
    standalone: false
})
export class CollectionOverviewComponent implements OnInit {
  collections$!: Observable<Collection[]>;

  constructor(private store: Store, private router: Router) {}

  breadcrumbScheme: any;
  breadcrumbs: Breadcrumb[] = [
    {
      label: 'Collecties',
      routerLink: ['/collections'],
    },
  ];

  ngOnInit(): void {
    this.collections$ = this.store.select(fromShopify.getAllCollections);

    // Set metadata
    this.store.dispatch(SetTitle({ title: `Collecties` }));
    this.store.dispatch(
      SetTags({
        properties: {
          'description': 'Collecties',
          'og:image': '',
          'og:title': 'Collecties',
          'og:description': 'Collecties',
        },
      })
    );

    this.setBreadcrumbScheme();
  }

  trackByFn(index: number, item: Collection) {
    return item.id;
  }

  setBreadcrumbScheme() {
    this.breadcrumbScheme = {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      'itemListElement': [
        {
          '@type': 'ListItem',
          'position': 1,
          'item': {
            '@type': 'Website',
            '@id': environment.storeDomain,
            'name': environment.storeName,
          },
        },
        {
          '@type': 'ListItem',
          'position': 2,
          'item': {
            '@type': 'CollectionPage',
            '@id': environment.storeDomain + this.router.url,
            'name': 'Collecties',
          },
        },
      ],
    };
  }
}
